
import { RevPopover } from '@ds/components/Popover'
import { RevTooltip } from '@ds/components/Tooltip'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { tw } from '@core/tailwind'
import productTranslations from '@product/pages/product.translations'

import translations from '../AddToCart/AddToCart.translations'
import { HIGHLIGHTED_PICKERS_VARIANTS } from '../HighlightedPickers/HighlightedPickers.constants'

import AnimatedPrice from './AnimatedPrice/AnimatedPrice.vue'

const selectedHighlightedPickersTypeStyles = {
  [HIGHLIGHTED_PICKERS_VARIANTS.info]: tw`text-info`,
  [HIGHLIGHTED_PICKERS_VARIANTS.accent]: tw`text-accent`,
}

export default {
  components: {
    RevPopover,
    RevTooltip,
    AnimatedPrice,
  },
  props: {
    price: {
      type: Object,
      required: true,
    },
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    isVatIncluded: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      breakpoint: 'breakpoint',
    }),
    isMobile() {
      return this.breakpoint < 2
    },
    priceType() {
      return this.selectedHighlightedPickers?.type
    },
    translations: () => translations,
    productTranslations: () => productTranslations,

    originalPriceDisplay() {
      return this.$t(translations.originalPriceDisplay, {
        price: this.$t.price(this.originalPrice),
      })
    },

    shouldDisplayOriginalPrice() {
      return !isEmpty(this.originalPrice)
    },

    priceStyle() {
      return (
        selectedHighlightedPickersTypeStyles[
          this.selectedHighlightedPickers?.type
        ] || tw`text-primary`
      )
    },
  },
}
